import {SET_CATEGORIES} from "../actions/categories";

const initialState = {
        isFetching: false,
        items: [],
        error: null
};

export default function categories (state = initialState , action = {}) {
    switch (action.type) {
        case SET_CATEGORIES :
            const { categories } = action;
            let categoryObj = catToObject(categories);
            return {
                isFetching: true,
                items: categoryObj,
                error: null
            };
            // break;
        default:
            return state;
    }
};
const catToObject= (array)=>{
    let arr = [];
    for (let key in array) {
        let cItem =array[key];
        arr[cItem.id] = cItem;
    }
    return arr;
};
/*
const catToObject= (array)=>{
    let arr = [];
    let parentArr = [];
    for (let key in array) {
        let cItem =array[key];
        cItem.hasChildren = false;
        arr[cItem.id] = cItem;
        let parentId = cItem.parent_id;
        if ((parentId !== "0") && (parentArr.indexOf(parseInt(parentId)) === -1)){
             parentArr.push(parseInt(parentId))
        }
    }
    const arr2 = arrayToObject(arr,parentArr);
    return arr2;

};
const arrayToObject = (array,parray) =>
    array.reduce((obj, item) => {
        if (parray.indexOf(item.id) !== -1){
            item.hasChildren = true;
        }
        obj[item.id] = item;
        return obj
    }, {});
 */



// WEBPACK FOOTER //
// ./src/redux/reducers/categories.js